import {theme} from "../../../../utils";

export const marginBottom = "1.5rem";
export const aiToolsInfoCardStyles = {
    container: {
        flexDirection: "column",
        display: "flex",
        alignItems: "center",
        flex: 1,
        px: 4,
        pt: 4,
        height: "100%",
    },
    sectionHeading: {
        marginTop:'20px',
        ...theme.typography.opticianBodyRegular,
        color: "#1C1B1A",
        fontSize: "40px",
        lineHeight: '100%',
        mb: marginBottom
    },
    vendorLogoList: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: 'space-between',
        mx: "auto",
        maxWidth: "600px",
        mb: marginBottom
    },
    vendorLogo: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: 'center',
        mx: "20px"

    },
    text: {
        ...theme.typography.poppinsBodyRegular,
        fontSize: "15px",
        fontWeight: 400,
        color: "#1E1E22",
        mx: "auto",
        lineHeight: '130%',
        letterSpacing: "0%",
        mb: marginBottom
    },
    btnContainer: {
        color: "#fff",
        textTransform: "capitalize",
        borderRadius: '8px',
        width: "424px",
        height: "53px",
        mb: marginBottom,
        mx: "auto",
    },
}